import * as TYPES from '../../store/types'
import { localStorageGetItem, localStorageSetItem } from '../../utils/local'
import { http } from '../../plugins/http'

const state = {
  intermediateGroup: '',
  cart: [],
}

const hasLocalCart = () => {
  if(localStorageGetItem('cart')) {
    if (localStorageGetItem('cart').length > 0) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

const saveToLocalCart = (cart) => {
  // TODO: For price update logic
  // cart.map( (item) => {
  //   delete item.price
  // })
  localStorageSetItem('cart', cart)
}

const mutations = {
  [TYPES.SET_INTERMEDIATE_GROUP](st, obj) {
    st.intermediateGroup = obj
  },
  [TYPES.SINGLE_REPLACE_CART](st, obj) {
    const existingArticle = st.cart.find(a => a.articleNumber === obj.articleNumber)

    if (existingArticle) {
      existingArticle.quantity = obj.quantity
    } else {
      st.cart.push(obj)
    }
  },
  [TYPES.SINGLE_ADD_TO_CART](st, obj) {
    const existingArticle = st.cart.find(a => a.articleNumber === obj.articleNumber)

    if (existingArticle) {
      existingArticle.quantity += obj.quantity
    } else {
      st.cart.push(obj)
    }

    saveToLocalCart(st.cart)
  },
  [TYPES.SINGLE_ARTICLE_QUANTITY](st, obj) {
    const existingArticle = st.cart.find(a => a.articleNumber === obj.articleNumber)

    if (existingArticle) {
      existingArticle.quantity = obj.quantity
    }

    saveToLocalCart(st.cart)
  },
  [TYPES.SINGLE_EMPTY_CART](st) {
    st.cart = []
    saveToLocalCart(st.cart)
  },
  [TYPES.SINGLE_REMOVE_FROM_CART](st, index) {
    st.cart.splice(index, 1)
    saveToLocalCart(st.cart)
  },
  [TYPES.SINGLE_ARTICLE_PRICE](st, obj) {
    const article = st.cart.find(a => a.articleNumber === obj.articleNumber)
    article.price = obj.price
    saveToLocalCart(st.cart)
  },
}

const getters = {
  activeGroup: (state) => {
    return state.intermediateGroup
  },
}

const actions = {
  loadCart({ commit }) {
    if (hasLocalCart()) {
      const localCart = localStorageGetItem('cart')

      // add from local to state
      localCart.map((article) => {
        // TODO: implement price update logic
        commit(TYPES.SINGLE_REPLACE_CART, article)

        http.get(`/catering/find/${article.articleNumber}`)
        .then(result => {
          const updatedPrice = result.data.Article.Price
          commit(TYPES.SINGLE_ARTICLE_PRICE, {
            articleNumber: article.articleNumber,
            price: updatedPrice
          })
        })
        .catch(error => {

        })
      })
    } // loadCart()
  },
  setIntermediateGroup({ commit }, obj) {
    commit(TYPES.SET_INTERMEDIATE_GROUP, obj)
  },
  singleAddToCart({ commit }, obj) {
    commit(TYPES.SINGLE_ADD_TO_CART, obj)
  },
  updateQuantity({ commit }, obj) {
    commit(TYPES.SINGLE_ARTICLE_QUANTITY, obj)
  },
  deleteFromCart({ commit }, obj) {
    const idx = state.cart.indexOf(obj)
    commit(TYPES.SINGLE_REMOVE_FROM_CART, idx)
  },
  emptyCart({ commit }) {
    commit(TYPES.SINGLE_EMPTY_CART)
  },
}

const module = {
  state,
  getters,
  mutations,
  actions,
}

export default { module }



// WEBPACK FOOTER //
// ./src/app/singleorder/vuex.js